import { shallowEqual, useSelector } from 'react-redux';

import { NsContent } from 'components/common/ns-content/NsContent';
import { AddressPlayback } from 'components/direct-sales/select-options/components/AddressPlayback';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { useMeterExceptions } from 'components/direct-sales/select-options/hooks/useMeterExceptions';
import { useIsExistingCustomer } from 'components/direct-sales/select-options/hooks/useIsExistingCustomer';
import { useMeterType } from 'hooks/useMeterType';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { getFuelValue } from 'components/direct-sales/fuel-type/getFuelValue';
import { FUEL_OPTIONS } from 'config/app-config';

export const testId = 'selectOptionsTestId';

type DataMapping = {
  gas: boolean;
  electricity: boolean;
  existingCustomerTitle: string;
};

const dataMapping: DataMapping[] = [
  {
    gas: true,
    electricity: false,
    existingCustomerTitle: 'Great, we already supply your gas'
  },
  {
    gas: false,
    electricity: true,
    existingCustomerTitle: 'Great, we already supply your electricity'
  },
  {
    gas: true,
    electricity: true,
    existingCustomerTitle: "Great, you're already with us"
  }
];

const getData = ({ gas, electricity }): DataMapping | undefined => {
  return dataMapping.find(
    (data) => data.gas === gas && data.electricity === electricity
  );
};

export const SelectOptionsHeader = () => {
  const { errors } = useMeterExceptions();
  const address = useSelector(selectedAddress, shallowEqual);
  const {
    isExistingCustomer,
    isExistingNEPCustomer,
    isExistingBGCustomer
  } = useIsExistingCustomer({ errors });
  const { existingCustomerTitle } =
    getData({
      gas: isExistingNEPCustomer.gas || isExistingBGCustomer.gas,
      electricity:
        isExistingNEPCustomer.electric || isExistingBGCustomer.electric
    }) ?? {};
  const { isRelatedElectricityMeter } = useMeterType();
    const fuelType = useSelector(selectFuelType, shallowEqual);
  const selectedFuelType =
      getFuelValue(fuelType) === FUEL_OPTIONS.DUAL
        ? 'Gas & Electricity'
        : getFuelValue(fuelType);

  const relatedMeterTitle = isRelatedElectricityMeter && selectedFuelType === FUEL_OPTIONS.ELECTRIC
    ? `We noticed you have a related meter`
    : `Join the UK's longest providing energy supplier.`;
  
  const title = isExistingCustomer ? existingCustomerTitle : relatedMeterTitle;

  return (
    <>
      <NsContent>
        <h1>{title}</h1>
      </NsContent>
      <AddressPlayback address={address} />
    </>
  );
};

export default SelectOptionsHeader;
